export type PopupTypes =
    | 'betfinder'
    | 'betslip'
    | 'bet-modal'
    | 'update-mobile-number'
    | 'my-bets'
    | 'sports'
    | 'grouped-sports'
    | 'archived-bets'
    | 'bet-generator'
    | 'transaction-bets'
    | 'bet-builder-overlay'
    | 'hr-help-overlay'
    | 'hr-info-overlay'
    | 'gr-help-overlay'
    | 'gr-info-overlay'
    | 'event-switcher'
    | 'ngrx-reports'
    | 'odds-change-preference';

export const DISPATCHER_EVENT_ON_POPUP_OPENED = 'ON_POPUP_OPENED';
